import React from 'react';
import {IconProps} from "./RightDropdownArrow";

const RightDropdownArrowMobile = (props: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="28"
			height="28"
			viewBox="0 0 28 28"
			fill="none"
		>
			<path
				d="M8 11L14 17L20 11"
				stroke={props.color ? props.color : '#fff'}
				strokeWidth="2"
			/>
		</svg>
	);
};

export default RightDropdownArrowMobile;